import React from "react";
import { galleryInstanceProps } from "./types";
import { useLazyLoad } from "../../../helpers/hooks";

const Comp = React.lazy(() => import("./Gallery"));

export default (props: galleryInstanceProps) =>
  useLazyLoad(<Comp {...props} />);
